export default __webpack_public_path__ + "static/media/portfolio-165.380c0266.jpg";